import { completar_String } from '../funciones_globales/format';

export const addItemArray = (array, item) => {
    let itemsArray = array.length;
    item.Nro = completar_String((itemsArray + 1).toString(), '0', 3);
    return [ ...array, item ];
}

export const deleteItemArray = (array, index) => {
    let indice = parseInt(index, 10);
    let arr_tmp = array.slice(0, indice).concat(array.slice(indice+1));
    arr_tmp.forEach((item, i)=>{
      item.Nro = completar_String((i + 1).toString(), '0', 3);
    });
    return arr_tmp;
}


/**
 * Takes an Array<V>, and a grouping function,
 * and returns a Map of the array grouped by the grouping function.
 *
 * @param list An array of type V.
 * @param keyGetter A Function that takes the the Array type V as an input, and returns a value of type K.
 *                  K is generally intended to be a property key of V.
 *
 * @returns Map of the array grouped by the grouping function.
 */
export const groupBy = (list, keyGetter) => {
    const map = new Map();
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    return map;
}